import EvalImportEvalCreate from './src/main';

/* istanbul ignore next */
EvalImportEvalCreate.install = function(Vue) {
  Vue.component(EvalImportEvalCreate.name, EvalImportEvalCreate);
};

export default EvalImportEvalCreate;
